import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

const FeatureGrid: React.FC = () => {
  return (
    <section className="py-5" id="features">
      <Container>
        <h2 className="text-center mb-5 fw-bold fs-2">Powerful SaaS Management Tools</h2>
        <Row>
          <Col md={4}>
            <Card className="feature-card">
              <CardBody>
                <i className="bx bx-buildings feature-icon"></i>
                <h4>Multi-Tenant Support</h4>
                <p>Manage multiple tenants with isolated data and custom connection strings.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="feature-card">
              <CardBody>
                <i className="bx bx-bell feature-icon"></i>
                <h4>Real-Time Notifications</h4>
                <p>Stay informed with instant alerts for tenant activities and system events.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="feature-card">
              <CardBody>
                <i className="bx bx-shield feature-icon"></i>
                <h4>Role-Based Permissions</h4>
                <p>Secure your platform with granular role and permission management.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="feature-card">
              <CardBody>
                <i className="bx bx-money feature-icon"></i>
                <h4>Flexible Subscriptions</h4>
                <p>Offer customizable pricing plans with monthly or yearly billing options.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="feature-card">
              <CardBody>
                <i className="bx bx-support feature-icon"></i>
                <h4>Support Ticketing</h4>
                <p>Provide seamless support with a robust ticketing and history tracking system.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="feature-card">
              <CardBody>
                <i className="bx bx-history feature-icon"></i>
                <h4>Audit Logging</h4>
                <p>Track all administrative actions for compliance and transparency.</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FeatureGrid;
